import React, { useState } from 'react';
import c from 'classnames';

import {
  CoreLink,
  RecursiveMenu,
} from '@uncinc/react-drupal-core';

import {
  Container,
  Hamburger,
  NavigationScroll,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_NORMAL } from '../../../config/constants';

import './style.scss';

const MainMenu = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_NORMAL;

  const MainMenuClassnames = c(
    'MainMenu',
    { 'mobile-menu-open': isMobileOpen },
  );

  return (
    <NavigationScroll>
      <div className={MainMenuClassnames}>
        <Container>
          <>
            <CoreLink
              to="/"
              className="MainMenu__logo"
            >
              Logo
            </CoreLink>

            {isMobile && (
              <>
                {isMobileOpen && (
                  <div className="MainMenu__mobile">
                    <Container>
                      <RecursiveMenu
                        menuId="main"
                        maxLevel={2}
                        onClickFunction={setIsMobileOpen}
                      />
                    </Container>
                  </div>
                )}
                <Hamburger
                  numberOfLines={isMobileOpen ? 2 : 3}
                  onClick={() => setIsMobileOpen((state) => !state)}
                />
              </>
            )}

            {!isMobile && (
              <div className="MainMenu__desktop">
                <Container>
                  <RecursiveMenu
                    menuId="main"
                    maxLevel={1}
                  />
                </Container>
              </div>
            )}
          </>
        </Container>
      </div>
    </NavigationScroll>
  );
};

export default MainMenu;
